import React from 'react';
import { clsx } from 'clsx';
import SafeIcon from '../common/SafeIcon';

export const Button = ({ 
  children, 
  variant = 'default', 
  size = 'md', 
  icon, 
  iconPosition = 'left',
  className,
  ...props 
}) => {
  const variants = {
    default: 'bg-primary text-primary-foreground hover:bg-primary/90 border-transparent',
    secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80 border-border',
    outline: 'bg-background text-foreground hover:bg-accent hover:text-accent-foreground border-input',
    ghost: 'bg-transparent text-foreground hover:bg-accent hover:text-accent-foreground border-transparent',
    destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90 border-transparent'
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
    icon: 'p-2'
  };

  return (
    <button
      className={clsx(
        'inline-flex items-center justify-center gap-2 rounded-md font-medium border transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {icon && iconPosition === 'left' && <SafeIcon icon={icon} />}
      {children}
      {icon && iconPosition === 'right' && <SafeIcon icon={icon} />}
    </button>
  );
};